import './AuthenticatedLayout.css'

import React from 'react'
import { useLocation } from 'react-router-dom'

import { Splitter, SplitterPanel } from 'primereact/splitter'
import { classNames } from 'primereact/utils'

import { useSplitViewContext } from '../../../contexts/splitView'
import { EInvoicePreview } from '../../../features/e-invoice/common/e-invoice-preview'
import { UserGuide, useUserGuideContext } from '../../../features/user-guide'
import { KeyboardShortcuts } from '../../KeyboardShortcuts'
import { Header } from './Header'
import { Main } from './Main'
import { Navigation } from './Navigation'

export const AuthenticatedLayout: React.FC = () => {
  const location = useLocation()
  const currentLocation = location.pathname
  const isNotSetTenantPath = currentLocation !== '/set-tenant'
  const { isUserGuideOpen } = useUserGuideContext()
  const { activeSplitView } = useSplitViewContext()

  // Determine if any split view is open
  const isSplitViewOpen =
    isUserGuideOpen || activeSplitView === 'eInvoicePreview'
  const gutterSize = isSplitViewOpen ? 4 : 0

  // Determine which panel to show
  const showUserGuide = isUserGuideOpen
  const showEInvoicePreview = activeSplitView === 'eInvoicePreview'

  return (
    <div className="layout-wrapper">
      <Header />

      {/* Content */}
      <div className="layout-content">
        <Splitter className="splitter" gutterSize={gutterSize}>
          {/* First half */}
          <SplitterPanel className="splitter-panel__content" minSize={50}>
            {/* Navigation */}
            {isNotSetTenantPath && <Navigation />}

            {/* Main */}
            <Main />
          </SplitterPanel>
          {/* Second half */}
          <SplitterPanel
            className={classNames('splitter-panel__user-guide', {
              open: isSplitViewOpen,
            })}
            size={0.01}
            minSize={25}
          >
            {/* User guide */}
            {showUserGuide && <UserGuide />}
            {/* E-Invoice Preview */}
            {showEInvoicePreview && <EInvoicePreview />}
          </SplitterPanel>
        </Splitter>
      </div>

      <KeyboardShortcuts />
    </div>
  )
}
